import React, { FC } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { CallCenter } from 'src/front/api/apiInstance';

import { Separator, Title } from 'src/front/components/FormStyles';
import { BREAK_POINTS } from 'src/front/constant';
import styled from 'styled-components';
import AccountSelectionForm from './components/AccountSelectionForm';

interface Props {
  goToNextStep: () => void;
}

export const FormRow = styled.div`
  width: auto;

  @media screen and (min-width: ${BREAK_POINTS.MIN.LARGE_2X}) {
    width: 1070px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_2X}) and (min-width: ${BREAK_POINTS.MIN
      .LARGE_1X}) {
    width: 970px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) and (min-width: ${BREAK_POINTS.MIN
      .TABLET}) {
    width: 870px;
  }
  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    width: 600px;
  }
`;

const logScreenOnce = (): (() => Promise<void>) => {
  let count = 0;

  const logScreen = async (): Promise<void> => {
    if (count === 0) {
      await CallCenter.logScreen({ screenCode: 'CEA30001' });
      count += 1;
    }
  };

  return logScreen;
};
const logScreen = logScreenOnce();

const AccountSelection: FC<Props> = ({ goToNextStep }) => {
  const { t } = useTranslation();

  const onContinue = async (): Promise<void> => {
    goToNextStep();
  };
  return (
    <>
      <Title>
        <Trans i18nKey={t('callCenter_internetBanking_interbankMoneyTransfersHistory_title')} />
      </Title>
      <Separator />

      <AccountSelectionForm logScreen={logScreen} onContinue={onContinue} />
    </>
  );
};
export default AccountSelection;
